// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2223":"91d32b09","4078":"b3eef437","4693":"b3eef437","6702":"b3eef437"}[chunkId] + ".chunk.css";
};